import React from 'react';
import { Box, Typography } from '@mui/material';

// TODO location will be added later with Translations
const DisclaimerNotice = ({ vetName, clinicName, location }) => {
    if (!vetName || !clinicName) return null;

    return (
        <Box sx={{ mt: 2, mb: 0 }}>
            <Typography variant="caption" sx={{ fontStyle: 'italic', color: '#666666', fontSize: 12 }}>
                This handout has been created by Cetra for Vets and edited by {vetName} of {clinicName}. This information is for guidance only and does not represent medical advice.
            </Typography>
        </Box>
    );
};

export default DisclaimerNotice;
